import gql from "graphql-tag";

const TAG_TRACKING_DELETE_EVENT = gql`
  mutation deleteEventsTarget($orgId: ID, $eventId: ID) {
    updateOrg(
      where: { id: $orgId }
      data: { eventsTarget: { delete: { id: $eventId } } }
    ) {
      id
      name
      eventsTarget {
        id
        name
        description
        pageViews
        signups
        transactions
        retailId
        cart
        test
        tag
        isAmplifyDefault
        segmentId
        segmentName
        tagUpdateDate
        uniqueDevices
        reports(where: { type: AUDIENCE }, first: 1, orderBy: createdAt_DESC) {
          id
          reportName
          key
          type
        }
        eventTags {
          id
          appId
        }
      }
    }
  }
`;

export default TAG_TRACKING_DELETE_EVENT;
